/*
 * SAM4S error-code browser (Sprint 7, 2026-09-22).
 *
 * Filtering and analytics only. Every code, meaning and safe check is rendered
 * server-side from sam4sdirect_error_code records, so the page answers the
 * visitor's question with JavaScript disabled and this file just makes a long
 * list usable at a counter.
 *
 * ON LEADS: searching and filtering are not leads and are never marked as
 * such. Only the support CTA carries lead: true. A person typing "40" into a
 * search box has told us nothing except that their printer is out of paper.
 */
(function () {
  function emit(event, payload) {
    var data = Object.assign({}, payload || {}, { event: event, page: window.location.pathname });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      try { window.Shopify.analytics.publish(event, data); } catch (e) { /* analytics must never break the page */ }
    }
    if (window.S4SGA4Forward) window.S4SGA4Forward(event, data);
  }

  function init(root) {
    if (root.dataset.s4ecReady) return;
    root.dataset.s4ecReady = '1';

    var items = [].slice.call(root.querySelectorAll('[data-s4ec-item]'));
    var groups = [].slice.call(root.querySelectorAll('[data-s4ec-group]'));
    var famButtons = [].slice.call(root.querySelectorAll('[data-s4ec-family]'));
    var search = root.querySelector('[data-s4ec-search]');
    var count = root.querySelector('[data-s4ec-count]');
    var empty = root.querySelector('[data-s4ec-empty]');
    var family = '';
    var term = '';

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var okFamily = !family || li.dataset.family === family;
        var okTerm = !term || (li.dataset.haystack || '').indexOf(term) > -1;
        var visible = okFamily && okTerm;
        li.hidden = !visible;
        if (visible) shown++;
      });
      // A family heading with nothing under it is noise, so it goes too.
      groups.forEach(function (g) {
        var any = [].slice.call(g.querySelectorAll('[data-s4ec-item]')).some(function (li) { return !li.hidden; });
        g.hidden = !any;
      });
      if (count) {
        count.textContent = shown === items.length
          ? shown + ' sourced messages'
          : shown + ' of ' + items.length + ' sourced messages';
      }
      if (empty) empty.hidden = shown !== 0;
    }

    famButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        family = btn.dataset.s4ecFamily || '';
        famButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        apply();
        emit('troubleshooting_family_selected', { family: family || 'all', lead: false });
      });
    });

    if (search) {
      var timer = null;
      search.addEventListener('input', function () {
        term = search.value.trim().toLowerCase();
        apply();
        // Debounced, and deliberately without the search text: what somebody
        // types while hunting a code is not something to ship to analytics.
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          emit('troubleshooting_search_used', { has_term: term.length > 0, lead: false });
        }, 700);
      });
    }

    root.addEventListener('toggle', function (event) {
      var d = event.target;
      if (!d || !d.hasAttribute || !d.hasAttribute('data-s4ec-details') || !d.open) return;
      var li = d.closest('[data-s4ec-item]');
      var code = d.querySelector('.s4ec__code');
      var msg = d.querySelector('.s4ec__msg');
      emit('error_code_expanded', {
        family: li ? li.dataset.family : null,
        code: code ? code.textContent.trim() : null,
        message: msg ? msg.textContent.trim() : null,
        lead: false,
      });
    }, true);

    apply();
  }

  /*
   * Link events are delegated from the document, not from the browser's own
   * root. The manual, support and replacement links live in the resources,
   * escalation and replacement zones further down the page - outside this
   * section entirely - and they still have to be measurable. Binding here once
   * covers every zone without a second copy of this file.
   */
  function currentFamily() {
    var active = document.querySelector('[data-s4ec] [data-s4ec-family].is-active');
    return (active && active.dataset.s4ecFamily) || 'all';
  }

  function bindLinkEvents() {
    if (document.documentElement.dataset.s4ecLinksReady) return;
    document.documentElement.dataset.s4ecLinksReady = '1';
    document.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-s4ec-event]') : null;
      if (!target) return;
      emit(target.dataset.s4ecEvent, {
        document_title: target.dataset.doc || null,
        family: currentFamily(),
        lead: target.dataset.lead === 'true',
      });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-s4ec]')).forEach(init);
    bindLinkEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
